import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./components/Login";
import Home from "./components/Home";
import Site from "./components/Site";
import Featured from "./components/Featured";
import ProductDetails from "./components/ProductDetails";
import ProductList from "./components/ProductList";
import Register from "./components/Register";
import ConfirmRegister from "./components/ConfirmRegister";
import IgniteFooter from "./components/IgniteFooter";
import Profile from "./components/Profile";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Payment from "./components/Payment";
import PaymentDemo from "./components/PaymentDemo";
import Logout from "./components/Logout";
import Confirm from "./components/Confirm";
import ConfirmEmail from "./components/ConfirmEmail";
import AdminUsers from "./components/admin/AdminUsers";
import UserDetails from "./components/admin/UserDetails";
import AdminHome from "./components/admin/Home";
import AdminOrders from "./components/admin/AdminOrders";
import AdminDecorators from "./components/admin/AdminDecorators";
import AdminPurchaseOrders from "./components/admin/AdminPurchaseOrders";
import AdminSubsites from "./components/admin/AdminSubsites";
import SubsiteDetails from "./components/admin/SubsiteDetails";
import AdminCatalog from "./components/admin/AdminCatalog";
import AdminContent from "./components/admin/AdminContent";
import AdminShipping from "./components/admin/AdminShipping";
import Catalog from "./components/admin/noncatalog/Catalog";
import AdminCategories from "./components/admin/AdminCategories";
import AdminFeatured from "./components/admin/AdminFeatured";
import AdminCommunication from "./components/admin/AdminCommunication";
import AdminProductDetails from "./components/admin/AdminProductDetails";
import { default as NCProductDetails} from "./components/admin/noncatalog/ProductDetails";
import AdminRoute from "./components/AdminRoute";
import NavRoute from "./components/NavRoute";
import PublicRoute from "./components/PublicRoute";
import AuthRoute from "./components/AuthRoute";
import AuthRetailRoute from "./components/AuthRetailRoute";
import CreditCardForm from "./components/CreditCardForm";
import LogoList from "./components/admin/logo/LogoList";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Maintenance from "./components/admin/AdminMaintenance";
import ContactUs from "./components/ContactUs";
import AdminUsersBulkEdit from "./components/admin/AdminUsersBulkEdit";
import Status from "./components/admin/AdminStatus";
import AdminClosedPO from "./components/admin/AdminClosedPO";
import AdminClosedPOList from "./components/admin/AdminClosedPOList";
import AdminClosedPODetails from "./components/admin/AdminClosedPODetails";
import AdminPriceCalculation from "./components/admin/AdminPriceCalculation";
import About from "./components/About";
import PrivacyPolicy from "./components/PrivacyPolicy";
import NotFound from "./components/NotFound";
import AdminNewHireKit from "./components/admin/AdminNewHireKit";
import AdminAddProduct from "./components/admin/AdminAddProduct";
import AdminIgniteProducts from "./components/admin/AdminIgniteProducts";

const App = () => {
  return (
    <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicRoute><Home/></PublicRoute>} />
            <Route path="/about" element={<PublicRoute><About/></PublicRoute>} />
            <Route path="/notfound" element={<PublicRoute><NotFound/></PublicRoute>} />
            <Route path="/forgotpassword" element={<PublicRoute><ForgotPassword/></PublicRoute>} />
            <Route path="/resetpassword" element={<PublicRoute><ResetPassword/></PublicRoute>} />
            <Route path="/s/:siteId" element={<Site/>} />
            <Route path="/home" element={<NavRoute><Home/></NavRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/contact" element={<PublicRoute><ContactUs/></PublicRoute>} />
            <Route path="/privacypolicy" element={<PublicRoute><PrivacyPolicy/></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
            <Route path="/confirmreg" element={<PublicRoute><ConfirmRegister /></PublicRoute>} />
            <Route path="/confirmnewreg" element={<PublicRoute><ConfirmRegister new={true}/></PublicRoute>} />
            <Route path="/confirmemail" element={<PublicRoute><ConfirmEmail /></PublicRoute>} />
            <Route path="/logout" element={<NavRoute><Logout /></NavRoute>} />

            <Route path="/featured" element={<AuthRetailRoute><Featured/></AuthRetailRoute>} />
            <Route path="/productlist/:categoryId" element={<AuthRetailRoute><ProductList/></AuthRetailRoute>} />
            <Route path="/productlist" element={<AuthRetailRoute><ProductList/></AuthRetailRoute>} />
            <Route path="/product/details/:productId" element={<AuthRetailRoute><ProductDetails /></AuthRetailRoute>} />
            <Route path="/cart" element={<AuthRetailRoute><Cart /></AuthRetailRoute>} />
 

            <Route path="/checkout" element={<AuthRoute><Checkout /></AuthRoute>} />
            {process.env.REACT_APP_ENV === "demo" && <Route path="/payment" element={<AuthRoute><PaymentDemo /></AuthRoute>} />}
            {process.env.REACT_APP_ENV !== "demo" && <Route path="/payment" element={<AuthRoute><Payment /></AuthRoute>} />}
            <Route path="/confirm" element={<AuthRoute><Confirm /></AuthRoute>} />
            <Route path="/processcc" element={<AuthRoute><CreditCardForm /></AuthRoute>} />
            <Route path="/profile" element={<AuthRoute><Profile/></AuthRoute>} />

            <Route path="/admin/home" element={<AdminRoute><AdminHome /></AdminRoute>} />
            <Route path="/admin/categories" element={<AdminRoute><AdminCategories /></AdminRoute>} />
            <Route path="/admin/content" element={<AdminRoute><AdminContent /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/admin/usersbulk" element={<AdminRoute><AdminUsersBulkEdit /></AdminRoute>} />
            <Route path="/admin/users/:userId" element={<AdminRoute><UserDetails /></AdminRoute>} />
            <Route path="/admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
            <Route path="/admin/purchaseorders" element={<AdminRoute><AdminPurchaseOrders /></AdminRoute>} />
            <Route path="/admin/subsites" element={<AdminRoute><AdminSubsites /></AdminRoute>} />
            <Route path="/admin/subsite/:subsiteId" element={<AdminRoute><SubsiteDetails /></AdminRoute>} />
            <Route path="/admin/catalog/:categoryId" element={<AdminRoute><AdminCatalog /></AdminRoute>} />
            <Route path="/admin/featured" element={<AdminRoute><AdminFeatured /></AdminRoute>} />
            <Route path="/admin/allcatalog/:categoryId" element={<AdminRoute><Catalog /></AdminRoute>} />
            <Route path="/admin/productlist" element={<AuthRoute><ProductList/></AuthRoute>} />
            <Route path="/admin/product/details/:productId" element={<AdminRoute><AdminProductDetails /></AdminRoute>} />
            <Route path="/admin/allproduct/details/:productId" element={<AdminRoute><NCProductDetails /></AdminRoute>} />
            <Route path="/admin/logos" element={<AdminRoute><LogoList /></AdminRoute>} />
            <Route path="/admin/communications" element={<AdminRoute><AdminCommunication /></AdminRoute>} />
            <Route path="/admin/decorators" element={<AdminRoute><AdminDecorators /></AdminRoute>} />
            <Route path="/admin/shipping" element={<AdminRoute><AdminShipping /></AdminRoute>} />
            <Route path="/admin/pricecalculation" element={<AdminRoute><AdminPriceCalculation /></AdminRoute>} />
            <Route path="/admin/maintenance" element={<AdminRoute><Maintenance /></AdminRoute>} />
            <Route path="/admin/status" element={<AdminRoute><Status /></AdminRoute>} />
            <Route path="/admin/closedpo" element={<AdminRoute><AdminClosedPO /></AdminRoute>} />
            <Route path="/admin/closedpos" element={<AdminRoute><AdminClosedPOList /></AdminRoute>} />
            <Route path="/admin/closedpo/:poId" element={<AdminRoute><AdminClosedPODetails /></AdminRoute>} />
            <Route path="/admin/newhirekits" element={<AdminRoute><AdminNewHireKit /></AdminRoute>} />            
            <Route path="/admin/addproduct" element={<AdminRoute><AdminAddProduct /></AdminRoute>} />
            <Route path="/admin/igniteproducts" element={<AdminRoute><AdminIgniteProducts /></AdminRoute>} />            
          </Routes>
          <div style={{paddingBottom: 100}}></div>


        </BrowserRouter>
        </div>
  );
};
export default App;